import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="relative py-0 overflow-hidden">
      {/* Background */}
      <div className="relative h-[500px] md:h-[600px]">
        <img
          src="https://public.readdy.ai/ai/img_res/8d32a1cb693ac5f850121625eae1abb3.jpg"
          alt="CTA Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-black/60" />

        {/* Content */}
        <div className="absolute inset-0 flex flex-col justify-center px-8 md:px-20">
          <div className="max-w-7xl mx-auto w-full flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
            {/* Left */}
            <div>
              <h2
                className="text-4xl md:text-6xl font-bold text-white leading-tight mb-4"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                turn your wisdom
                <br />
                into income.
              </h2>
              <Link
                to="/payment"
                className="inline-flex items-center gap-3 bg-white rounded-full pl-6 pr-2 py-2 cursor-pointer hover:bg-teal-50 transition-colors group"
              >
                <span className="text-gray-900 font-semibold text-sm whitespace-nowrap">Link &amp; Earn</span>
                <span className="w-9 h-9 flex items-center justify-center bg-gray-900 group-hover:bg-teal-600 rounded-full transition-colors">
                  <i className="ri-arrow-right-line text-white" />
                </span>
              </Link>
            </div>

            {/* Right */}
            <div className="max-w-sm">
              <p className="text-white/80 text-lg leading-relaxed mb-6">
                Link your bank account, set your rates, and start earning from your coaching expertise. Mind Odyssey handles payments so you can focus on impact.
              </p>
              <div className="flex flex-col gap-3">
                {[
                  { icon: "ri-bank-card-line", text: "Secure bank account linking" },
                  { icon: "ri-shield-check-line", text: "Encrypted payment processing" },
                  { icon: "ri-money-dollar-circle-line", text: "Weekly payouts to your account" },
                ].map((item) => (
                  <div key={item.text} className="flex items-center gap-3">
                    <div className="w-8 h-8 flex items-center justify-center bg-teal-500/20 rounded-lg">
                      <i className={`${item.icon} text-teal-400`} />
                    </div>
                    <span className="text-white/70 text-sm">{item.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
